import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const marqueeTexts = [
  'World’s First',
  'Dual Identity',
  'Campus Social Network',
  'Reality Mode',
  'Verified Students',
  'Campus Pulse',
  'Find Your Squad',
  'Vibe Check',
  'Authentic',
  'Zero Pressure',
  'Belong',
  'Global Reach',
];

const marqueeTexts2 = [
  'Shadow Mode',
  'Drop Truths',
  'Anon Chat',
  'No Judgment',
  'Unfiltered',
  'Campus Tea',
  'Expose Secrets',
  'No Filters',
  'Digital Twin',
  'Bimodal Social',
  'Total Privacy',
  'Your Alter Ego',
];

export const ScrollStrip = ({ direction = 'left' }) => {
  const texts = direction === 'left' ? marqueeTexts : marqueeTexts2;
  const duplicatedTexts = [...texts, ...texts, ...texts];

  const containerRef = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setWidth(containerRef.current.scrollWidth / 3);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial calculation

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="relative overflow-hidden py-6 my-8">
      {/* Glass background */}
      <div className="absolute inset-0 glass-strip" />

      <motion.div
        ref={containerRef}
        className="flex gap-6 whitespace-nowrap"
        animate={{
          x: direction === 'left' ? [0, -width] : [-width, 0],
        }}
        transition={{
          duration: 14,
          repeat: Infinity,
          ease: 'linear',
        }}
      >
        {duplicatedTexts.map((text, index) => (
          <div
            key={index}
            className="text-2xl md:text-3xl font-bold text-sp-cyan opacity-80"
          >
            {text}
            <span className="mx-4 text-[#06B6D4]">•</span>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default ScrollStrip;



